import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../Enums/MagicField.enum';

const formScheme: ItemScheme[] = [
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.CONTAINER,
				key: 'magneticResonance',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Resonancia Magnética',
					},
					{
						settings: {
							rules: [
								{
									formControlKey: 'magneticResonance.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						type: MagicField.CONDITION,
						subtype: 'view',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										key: 'text',
										settings: {
											required: true,
										},
									},
									{
										type: MagicField.RADIOLIST,
										key: 'contrast',
										settings: {
											required: true,
										},
										inLine: true,
										children: [
											{
												value: '1',
												title: 'con contraste',
											},
											{
												value: '0',
												title: 'sin contraste',
											},
										],
									},
								],
							},
						],
					},
				],
			},
			{
				type: MagicField.CONTAINER,
				key: 'computedTomography',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Tomografía Computarizada',
					},
					{
						settings: {
							equal: true,
						},
						type: MagicField.CONDITION,
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										key: 'text',
										settings: {
											required: true,
										},
									},
									{
										type: MagicField.RADIOLIST,
										key: 'contrast',
										settings: {
											required: true,
										},
										inLine: true,
										children: [
											{
												value: '1',
												title: 'con contraste',
											},
											{
												value: '0',
												title: 'sin contraste',
											},
										],
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.CONTAINER,
				key: 'digitalXRay',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Rayos X Digital',
					},
					{
						type: MagicField.CONDITION,
						settings: {
							rules: [
								{
									formControlKey: 'digitalXRay.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										key: 'text',
										settings: {
											required: true,
										},
									},
								],
							},
						],
					},
				],
			},
			{
				type: MagicField.CONTAINER,
				key: 'coronaryArteryTomography',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Tomografía de Arterias Coronarias',
					},
					{
						type: MagicField.CONDITION,
						settings: {
							rules: [
								{
									formControlKey: 'coronaryArteryTomography.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										key: 'text',
										settings: {
											required: true,
										},
									},
									{
										type: MagicField.RADIOLIST,
										key: 'contrast',
										settings: {
											required: true,
										},
										inLine: true,
										children: [
											{
												value: '1',
												title: 'con contraste',
											},
											{
												value: '0',
												title: 'sin contraste',
											},
										],
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.CONTAINER,
		key: 'ultrasound',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'Ecografía',
				defaultValue: true,
			},
			{
				type: MagicField.CONDITION,
				subtype: 'view',
				settings: {
					rules: [
						{
							formControlKey: 'ultrasound.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.CHECKBOX,
								key: 'thyroid',
								title: 'Tiroidea',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'abdominal',
								title: 'Abdominal',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'transrectalProstate',
								title: 'Prostática Transrectal',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'mammary',
								title: 'Mamaria',
							},
							{
								type: MagicField.CONTAINER,
								key: 'softParts',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: 'toggle',
										title: 'Partes blandas',
									},
									{
										type: MagicField.CONDITION,
										subtype: 'view',
										settings: {
											rules: [
												{
													formControlKey: 'ultrasound.softParts.toggle',
													rule: 'equal',
													value: true,
												},
											],
										},
										children: [
											{
												type: MagicField.CONTAINER,
												settings: {
													showLine: true,
												},
												children: [
													{
														type: MagicField.TEXT_FIELD,
														key: 'specify',
														settings: {
															required: true,
														},
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CONTAINER,
								key: 'articulate',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: 'toggle',
										title: 'Articular',
									},
									{
										type: MagicField.CONDITION,
										subtype: 'view',
										value: 'toggle',
										settings: {
											rules: [
												{
													formControlKey: 'ultrasound.articulate.toggle',
													rule: 'equal',
													value: true,
												},
											],
										},
										children: [
											{
												type: MagicField.CONTAINER,
												settings: {
													showLine: true,
												},
												children: [
													{
														type: MagicField.TEXT_FIELD,
														key: 'specify',
														settings: {
															required: true,
														},
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CONTAINER,
								key: 'vascularDoppler',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: 'toggle',
										title: 'Doppler Vascular',
									},
									{
										type: MagicField.CONDITION,
										subtype: 'view',
										value: 'toggle',
										settings: {
											rules: [
												{
													formControlKey: 'ultrasound.vascularDoppler.toggle',
													rule: 'equal',
													value: true,
												},
											],
										},
										children: [
											{
												type: MagicField.CONTAINER,
												settings: {
													showLine: true,
												},
												children: [
													{
														type: MagicField.TEXT_FIELD,
														key: 'specify',
														settings: {
															required: true,
														},
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CONTAINER,
								key: 'obstetric',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: 'toggle',
										title: 'Obstétrica',
										defaultValue: true,
									},
									{
										type: MagicField.CONDITION,
										subtype: 'view',
										value: 'toggle',
										settings: {
											rules: [
												{
													formControlKey: 'ultrasound.obstetric.toggle',
													rule: 'equal',
													value: true,
												},
											],
										},
										children: [
											{
												type: MagicField.CONTAINER,
												settings: {
													showLine: true,
												},
												children: [
													{
														type: MagicField.CHECKBOX,
														title: 'General',
														key: 'general',
														defaultValue: true,
													},
													{
														type: MagicField.CHECKBOX,
														title: '3D',
														key: '3D',
														defaultValue: true,
													},
													{
														type: MagicField.CHECKBOX,
														title: '4D',
														key: '4D',
														defaultValue: true,
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CONTAINER,
								key: 'doppler',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: 'toggle',
										title: 'Doppler',
									},
									{
										type: MagicField.CONDITION,
										subtype: 'view',
										value: 'toggle',
										settings: {
											rules: [
												{
													formControlKey: 'ultrasound.doppler.toggle',
													rule: 'equal',
													value: true,
												},
											],
										},
										children: [
											{
												type: MagicField.CONTAINER,
												settings: {
													showLine: true,
												},
												children: [
													{
														type: MagicField.TEXT_FIELD,
														key: 'specify',
														settings: {
															required: true,
														},
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CONTAINER,
								key: 'pelvico',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: 'toggle',
										title: 'Pélvica',
									},
									{
										type: MagicField.CONDITION,
										subtype: 'view',
										value: 'toggle',
										settings: {
											rules: [
												{
													formControlKey: 'ultrasound.pelvico.toggle',
													rule: 'equal',
													value: true,
												},
											],
										},
										children: [
											{
												type: MagicField.CONTAINER,
												settings: {
													showLine: true,
												},
												children: [
													{
														type: MagicField.CHECKBOX,
														title: 'Transabdominal',
														key: 'transabdominal',
													},
													{
														type: MagicField.CHECKBOX,
														title: 'Transvaginal',
														key: 'transvaginal',
													},
												],
											},
										],
									},
								],
							},
							{
								type: MagicField.CONTAINER,
								key: 'other',
								children: [
									{
										type: MagicField.CHECKBOX,
										key: 'toggle',
										title: 'Otra',
									},
									{
										type: MagicField.CONDITION,
										subtype: 'view',
										value: 'toggle',
										settings: {
											rules: [
												{
													formControlKey: 'ultrasound.other.toggle',
													rule: 'equal',
													value: true,
												},
											],
										},
										children: [
											{
												type: MagicField.CONTAINER,
												settings: {
													showLine: true,
												},
												children: [
													{
														type: MagicField.TEXT_FIELD,
														key: 'specify',
														settings: {
															required: true,
														},
													},
												],
											},
										],
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.HSTACK,
		children: [
			{
				type: MagicField.CONTAINER,
				key: 'digitalMammography',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Mamografía digital',
					},
					{
						type: MagicField.CONDITION,
						settings: {
							rules: [
								{
									formControlKey: 'digitalMammography.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										key: 'specify',
										settings: {
											required: true,
										},
									},
								],
							},
						],
					},
				],
			},
			{
				type: MagicField.CONTAINER,
				key: 'digitalMammography3D',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Mamografía en 3D – Tomosíntesis',
					},
					{
						type: MagicField.CONDITION,
						settings: {
							rules: [
								{
									formControlKey: 'digitalMammography3D.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										key: 'specify',
										settings: {
											required: true,
										},
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.CONTAINER,
		key: 'boneDensitometryByDEXA',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'toggle',
				title: 'Densitometría Ósea por DEXA',
			},
			{
				settings: {
					rules: [
						{
							formControlKey: 'boneDensitometryByDEXA.toggle',
							rule: 'equal',
							value: true,
						},
					],
				},
				type: MagicField.CONDITION,
				subtype: 'view',
				value: 'toggle',
				children: [
					{
						type: MagicField.CONTAINER,
						settings: {
							showLine: true,
						},
						children: [
							{
								type: MagicField.CHECKBOX,
								key: 'l1l4',
								title: 'L1-L4',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'rightHip',
								title: 'Cadera derecha',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'leftHip',
								title: 'Cadera Izquierda',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'forearm',
								title: 'Antebrazo',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'lateralThoracolumbarSpine',
								title: 'Columna Dorsolumbar lateral',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'morphometry',
								title: 'Morfometria',
							},
							{
								type: MagicField.CHECKBOX,
								key: 'bodyComposition',
								title: 'Composición Corporal',
							},
							{
								type: MagicField.TEXT_FIELD,
								key: 'presumptiveDiagnosis',
								title: 'Diagnóstico presuntivo',
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.HR,
	},
	{
		type: MagicField.TEXT,
		title: 'Estudios especializados',
		subType: 'header',
	},
	{
		type: MagicField.TEXT,
		title: 'Cardiología Diagnóstica',
		subType: 'subtitle',
	},
	{
		type: MagicField.CONTAINER,
		key: 'cardiology',
		children: [
			{
				type: MagicField.CONTAINER,
				key: 'electrocardiogram',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Electrocardiograma',
					},
					{
						type: MagicField.CONDITION,
						settings: {
							rules: [
								{
									formControlKey: 'cardiology.electrocardiogram.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										key: 'text',
									},
								],
							},
						],
					},
				],
			},
			{
				type: MagicField.CHECKBOX,
				key: 'stressTest',
				title: 'Prueba de Esfuerzo',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'echocardiogram',
				title: 'Ecocardiograma',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'ecoStress',
				title: 'Eco-Stress',
			},
			{
				type: MagicField.CHECKBOX,
				key: 'ecoStressWithDobutamine',
				title: 'Eco Stress con Dobutamina',
			},
			{
				type: MagicField.CHECKBOX,
				key: '24HourHolter',
				title: 'Holter 24 horas',
			},
			{
				type: MagicField.CHECKBOX,
				key: '24HourMap',
				title: 'MAPA 24 horas',
			},
			{
				type: MagicField.CONTAINER,
				key: 'cardiologyOther',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'Otros',
					},
					{
						type: MagicField.CONDITION,
						settings: {
							rules: [
								{
									formControlKey: 'cardiology.cardiologyOther.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.TEXT_FIELD,
										title: 'base.specify',
										key: 'specify',
										settings: {
											required: true,
										},
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.WHITESPACE,
	},
	{
		type: MagicField.TEXT,
		title: 'Neurofisiología',
		subType: 'subtitle',
	},
	{
		type: MagicField.CONTAINER,
		key: 'neurophysiology',
		children: [
			{
				type: MagicField.CHECKBOX,
				key: 'electroencephalogram',
				title: 'Electroencefalograma',
			},
			{
				type: MagicField.CONTAINER,
				key: 'emgPerExtremity',
				children: [
					{
						type: MagicField.CHECKBOX,
						key: 'toggle',
						title: 'EMG por extremidad',
					},
					{
						type: MagicField.CONDITION,
						settings: {
							rules: [
								{
									formControlKey: 'neurophysiology.emgPerExtremity.toggle',
									rule: 'equal',
									value: true,
								},
							],
						},
						subtype: 'view',
						value: 'toggle',
						children: [
							{
								type: MagicField.CONTAINER,
								settings: {
									showLine: true,
								},
								children: [
									{
										type: MagicField.CONTAINER,
										key: 'lowerLimbs',
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'toggle',
												title: 'Miembro Inferior',
											},
											{
												type: MagicField.CONDITION,
												settings: {
													rules: [
														{
															formControlKey:
																'neurophysiology.emgPerExtremity.lowerLimbs.toggle',
															rule: 'equal',
															value: true,
														},
													],
												},
												subtype: 'view',
												value: 'toggle',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																type: MagicField.CHECKBOX,
																key: 'limbsRight',
																title: 'Derecho',
															},
															{
																type: MagicField.CHECKBOX,
																key: 'limbsLeft',
																title: 'Izquierdo',
															},
														],
													},
												],
											},
										],
									},
									{
										type: MagicField.CONTAINER,
										key: 'upperLimbs',
										children: [
											{
												type: MagicField.CHECKBOX,
												key: 'toggle',
												title: 'Miembro Superior',
											},
											{
												type: MagicField.CONDITION,
												settings: {
													rules: [
														{
															formControlKey:
																'neurophysiology.emgPerExtremity.upperLimbs.toggle',
															rule: 'equal',
															value: true,
														},
													],
												},
												subtype: 'view',
												value: 'toggle',
												children: [
													{
														type: MagicField.CONTAINER,
														settings: {
															showLine: true,
														},
														children: [
															{
																type: MagicField.CHECKBOX,
																key: 'limbsRight',
																title: 'Derecho',
															},
															{
																type: MagicField.CHECKBOX,
																key: 'limbsLeft',
																title: 'Izquierdo',
															},
														],
													},
												],
											},
										],
									},
								],
							},
						],
					},
				],
			},
		],
	},
	{
		type: MagicField.TEXTAREA,
		key: 'clinicalHistoryComments',
		title: 'Historia Clínica/ Comentarios',
	},
	{
		type: MagicField.TEXTAREA,
		key: 'additionalNote',
		title: 'Nota adicional',
	},
	{
		type: MagicField.TEXTAREA,
		key: 'anotherAdditionalStudy',
		title: 'Otro estudio adicional',
	},
];

export default formScheme;
